import {useCallback} from 'react';
import {useNavigate} from "react-router-dom";
import type {HelpProps} from '@yosmanyga/fortaleza-core';
import {Help} from '@yosmanyga/fortaleza-core';
import {BlankLayout} from '../BlankLayout.tsx';

const HelpScreen = () => {
    const navigate = useNavigate();

    const Layout = useCallback<HelpProps['templates']['layout']>(({texts, ...props}) => {
        return <BlankLayout
            onBack={() => {
                navigate(-1);
            }}
            flex
            scroll
            margin={{
                top: 1
            }}
            {...props}
        >
            {texts}
        </BlankLayout>
    }, [])

    return <Help
        templates={{
            layout: Layout,
        }}
    />
};

export {HelpScreen};
